export interface IValidationError {
    fieldName: string;
    messages: Array<string>;
}

export interface IApiError {
    message: string;
    hasValidationErrors: boolean;
    validationErrors?: Array<IValidationError>;

}

export class ApiError implements IApiError {
    message: string;
    hasValidationErrors: boolean;
    validationErrors?: Array<IValidationError>;
}